import { AppNS } from '..';
import { AppThunk } from './index';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { apiGenerateCsvReport, apiGetCsvReportState } from 'app/api/csv-reports/csv-reports';

const POLLING_DELAY = 3000;

export interface CsvReportState {
  errorMessage: string;
  isActionLoading: boolean;
  isActionSuccess: boolean;
  currentCsvReportId: string;
  currentCsvReportUrl: string;
  delay: number | null;
}

const initialState: CsvReportState = {
  errorMessage: '',
  isActionLoading: false,
  isActionSuccess: false,
  currentCsvReportId: '',
  currentCsvReportUrl: '',
  delay: POLLING_DELAY,
};

const csvReports = createSlice({
  name: 'csvReports',
  initialState,
  reducers: {
    actionStart(state: CsvReportState, action: PayloadAction<AppNS.Params>) {
      state.isActionLoading = true;
      state.currentCsvReportId = action.payload.id;
    },

    actionSuccess(state: CsvReportState, action: PayloadAction<AppNS.Params>) {
      if (action.payload.state === 'completed') {
        state.isActionLoading = false;
        state.isActionSuccess = true;
        state.currentCsvReportUrl = action.payload.url.url;
        state.delay = null;
      } else if (action.payload.state === 'failed') {
        state.isActionLoading = false;
        state.isActionSuccess = false;
        state.delay = null;
      } else if (action.payload.state === 'in_progress') {
        state.currentCsvReportId = action.payload.id;
        state.isActionLoading = true;
        state.isActionSuccess = false;
      }
    },
    reset(state: CsvReportState) {
      state.errorMessage = '';
      state.isActionLoading = false;
      state.isActionSuccess = false;
      state.currentCsvReportId = '';
      state.currentCsvReportUrl = '';
      state.delay = POLLING_DELAY;
    },
  },
});

export const {
  actionStart,
  actionSuccess,
  reset,
} = csvReports.actions;

export default csvReports.reducer;

export const getCsvReportState =
  (reportId: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(actionStart({ id: reportId }));
      const response = await apiGetCsvReportState(reportId);
      dispatch(actionSuccess(response));
    } catch (err) {
      if (err) {
        dispatch(reset());
      }
    }
  };

export const generateCsvReport =
  (params: AppNS.Params): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(actionStart({}));
      const response = await apiGenerateCsvReport(params);
      dispatch(actionSuccess(response));
    } catch (err) {
      if (err) {
        dispatch(reset());
      }
    }
  };
